import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import IssuePreviewTransitionPopUpForm from './IssuePreviewTransitionPopUpForm';
import useCurrentIssuePreviewPopup from './useCurrentIssuePreviewPopup';

const useResetCurrentIssuePreviewPopupOnUnmount = () => {
  const {setCurrentIssuePreviewPopup} = useCurrentIssuePreviewPopup();
  useEffect(
    () => () => {
      setCurrentIssuePreviewPopup(null);
    },
    [setCurrentIssuePreviewPopup]
  );
};

const IssuePreviewTransitionPopUp = ({isOpen, changeToStatus, onStatusChange}) => {
  useResetCurrentIssuePreviewPopupOnUnmount();
  return (
    <div className="IssuePreviewTransitionPopUp">
      {(changeToStatus && isOpen && (
        <IssuePreviewTransitionPopUpForm changeToStatus={changeToStatus} onStatusChange={onStatusChange} />
      )) ??
        null}
    </div>
  );
};

IssuePreviewTransitionPopUp.displayName = 'IssuePreviewTransitionPopUp';

IssuePreviewTransitionPopUp.propTypes = {
  isOpen: PropTypes.bool,
  changeToStatus: PropTypes.string,
  onStatusChange: PropTypes.func.isRequired
};

export default IssuePreviewTransitionPopUp;
